exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Pin {\r\n\tposition: relative;\r\n}\r\n\r\n.Pin i {\r\n\ttransform: translate(-1px, 1px) rotateZ(45deg);\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/Pin/Pin.css
// module id = 698
// module chunks = 0